export function resolvePreferredDevices({ audios, videos, audioOutputs, }) {
    let selectedAudio;
    let selectedVideo;
    let selectedAudioOutput;
    if (localStorage.getItem('video')) {
        selectedVideo = videos?.find((device) => device.label === localStorage.getItem('video'));
    }
    if (localStorage.getItem('micro')) {
        selectedAudio = audios?.find((device) => device.label === localStorage.getItem('micro'));
    }
    if (localStorage.getItem('speaker')) {
        selectedAudioOutput = audioOutputs?.find((device) => device.label === localStorage.getItem('speaker'));
    }
    return {
        selectedAudio,
        selectedAudioOutput,
        selectedVideo,
    };
}
